import React from 'react';
import moment from 'moment';
import { GIFT_IDEAS_ARRAY, GIFT_IDEAS_ARRAY_ES } from '../define/giftIdeas';
import { SEASONAL_GIFT_IDEAS_ARRAY, SEASONAL_GIFT_IDEAS_ARRAY_ES, LESS_IMPORTANT_SEASONAL_GIFT_IDEAS_ARRAY, LESS_IMPORTANT_SEASONAL_GIFT_IDEAS_ARRAY_ES } from '../define/giftIdeas';

function stringToDate(dateString, returnEndOfMonth = false) {
  const current_year = moment().format('YYYY');
  if (dateString.includes('-')) {
    return moment(current_year + '-' + dateString, 'YYYY-MM-DD');
  } else {
    if (returnEndOfMonth) {
      return moment(
        current_year + '-' + dateString + '-01',
        'YYYY-MM-DD'
      ).endOf('month');
    } else {
      return moment(current_year + '-' + dateString + '-01', 'YYYY-MM-DD');
    }
  }
}

export function getGiftIdeas(isSpanishEnv = false) {
  const currentDate = moment();

  const seasonalArray = isSpanishEnv ? SEASONAL_GIFT_IDEAS_ARRAY_ES : SEASONAL_GIFT_IDEAS_ARRAY;
  const lessImportantSeasonalArray = isSpanishEnv ? LESS_IMPORTANT_SEASONAL_GIFT_IDEAS_ARRAY_ES : LESS_IMPORTANT_SEASONAL_GIFT_IDEAS_ARRAY;
  const giftIdeasArray = isSpanishEnv ? GIFT_IDEAS_ARRAY_ES : GIFT_IDEAS_ARRAY;

  const filterByDate = (array) =>
    array.filter(
      (item) => item && item.start && item.end && currentDate >= item.start && currentDate <= item.end
    );

  return [...filterByDate(seasonalArray), ...giftIdeasArray, ...filterByDate(lessImportantSeasonalArray)];
}
